function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 19 19",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    }
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 18.033,
    height: 18.033,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.867,3.28c-0.852,-0.773 -1.979,-1.171 -3.127,-1.105c-0.382,0.003 -0.761,0.067 -1.123,0.191c-0.377,0.125 -0.737,0.299 -1.069,0.517c-0.332,0.216 -0.616,0.419 -0.851,0.61c-0.236,0.189 -0.462,0.391 -0.676,0.605c-0.215,-0.214 -0.44,-0.416 -0.677,-0.605c-0.238,-0.19 -0.522,-0.393 -0.851,-0.61c-0.332,-0.218 -0.691,-0.392 -1.069,-0.517c-0.361,-0.124 -0.741,-0.188 -1.123,-0.191c-1.146,-0.065 -2.271,0.334 -3.12,1.105c-0.792,0.816 -1.208,1.928 -1.146,3.064c0.003,0.418 0.074,0.833 0.21,1.229c0.119,0.376 0.278,0.738 0.476,1.079c0.182,0.304 0.384,0.596 0.606,0.873c0.225,0.283 0.392,0.477 0.499,0.583c0.079,0.082 0.162,0.159 0.25,0.231l5.558,5.367c0.216,0.213 0.567,0.213 0.784,0l5.54,-5.352c1.189,-1.008 1.924,-2.453 2.04,-4.008c0.066,-1.134 -0.344,-2.246 -1.131,-3.066Z",
    style: {
      fillRule: "nonzero"
    }
  }));
};
export default SvgHeart;